import React from 'react';
import { useIsMobile } from "../../Common/useIsMobile";
import CefCard from "../../Layout/CefCard";
import Content from "./Content";
var CheckEligibilityIntro = function CheckEligibilityIntro(_ref) {
  var onExit = _ref.onExit;
  var isMobile = useIsMobile();
  var checkEligibilityIntroContent = /*#__PURE__*/React.createElement(Content, {
    onExit: onExit
  });
  return isMobile ? checkEligibilityIntroContent : /*#__PURE__*/React.createElement(CefCard, null, checkEligibilityIntroContent);
};
export default CheckEligibilityIntro;